import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const SAVED_FILTERS_KEY = 'tcg-calendar-last-filters';
const FILTERABLE_PATHS = [
  '/',
  '/pokemon-competitions',
  '/onepiece-competitions',
  '/magic-competitions',
  '/riftbound-competitions',
  '/lorcana-competitions',
  '/fleshandblood-competitions',
];

const isFilterablePath = (pathname: string) => (
  FILTERABLE_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`))
);

const SavedFilterSync: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const restored = useRef(false);

  useEffect(() => {
    if (restored.current) return;
    restored.current = true;

    if (location.pathname !== '/' || location.search) return;

    let savedPath: string | null = null;
    try {
      savedPath = window.localStorage.getItem(SAVED_FILTERS_KEY);
    } catch {
      // Storage denied; no saved filters to restore.
    }
    if (savedPath && savedPath !== '/' && isFilterablePath(savedPath.split('?')[0])) {
      navigate(savedPath, { replace: true });
    }
  }, [location.pathname, location.search, navigate]);

  useEffect(() => {
    if (!isFilterablePath(location.pathname)) return;
    try {
      window.localStorage.setItem(SAVED_FILTERS_KEY, `${location.pathname}${location.search}`);
    } catch {
      // Storage denied; navigation still works without persistence.
    }
  }, [location.pathname, location.search]);

  return null;
};

export default SavedFilterSync;
